<template>
  <router-view />
</template>
<script>
export default {
  name: 'AuthSite',
  data: () => ({ previousTitle: '' }),
  computed: {
    pageTitle() { return this.$route.meta.titleKey ? this.$t(this.$route.meta.titleKey) : ''; },
  },
  watch: { pageTitle: 'updateTitle' },
  mounted() { this.previousTitle = document.title; this.updateTitle(); },
  beforeUnmount() { document.title = this.previousTitle; },
  methods: {
    updateTitle() { if (this.previousTitle) document.title = (this.pageTitle ? this.pageTitle + ' | ' : '') + 'Leader'; },
  },
};
</script>
